import { render, staticRenderFns } from "./jarreos.vue?vue&type=template&id=d2199692&scoped=true&"
import script from "./jarreos.vue?vue&type=script&lang=js&"
export * from "./jarreos.vue?vue&type=script&lang=js&"
import style0 from "./jarreos.vue?vue&type=style&index=0&id=d2199692&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2199692",
  null
  
)

export default component.exports